export default process.env.VUE_APP_DEVICE === 'mobile'
  ? require('../../config/config.json')
  : window.HM_CONFIG
